import { render, staticRenderFns } from "./WeightClassesCombo.vue?vue&type=template&id=670d011e&scoped=true"
import script from "./WeightClassesCombo.vue?vue&type=script&lang=js"
export * from "./WeightClassesCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670d011e",
  null
  
)

export default component.exports